
import Vue from "vue"
import {
  QBtn,
  QBtnDropdown,
  QHeader,
  QItemLabel,
  QItemSection,
  QSeparator,
  QSpace,
  QToolbar,
  QToolbarTitle,
} from "quasar"
import MenuIcon from "@/layout/MenuIcon.vue"
import Component from "vue-class-component"
import {Inject} from "vue-property-decorator"
import {AuthenticationService} from "@/AuthenticationService"
import MfaSetupComponent from "@/login/MfaSetup.vue"
import ChangePasswordComponent from "@/login/ChangePassword.vue"
import {PlanService} from "@/superannuation/PlanService"
import Message from "@/components/Message.vue"
import {format} from "date-fns"
import {ActuatorInfo, ActuatorService, Commit} from "@/ActuatorService"

interface BuildInfo {
  commit: Commit
  build: {number: string; time: string}
}

@Component({
  components: {
    Message,
    QHeader,
    QToolbar,
    QBtn,
    QToolbarTitle,
    QSeparator,
    QSpace,
    QBtnDropdown,
    QItemSection,
    QItemLabel,
    MenuIcon,
    MfaSetupComponent,
    ChangePasswordComponent,
  },
})
export default class AppHeader extends Vue {
  @Inject()
  authenticationService: AuthenticationService

  @Inject()
  planService: PlanService

  @Inject()
  actuatorService: ActuatorService

  showForm = false
  show2fa = false
  isStaff = false
  actuatorInfo: ActuatorInfo | null = null
  buildInfo: BuildInfo | null = null

  async created() {
    this.isStaff = await this.authenticationService.isStaff()
    this.actuatorInfo = await this.actuatorService.getInfo()

    if (this.actuatorInfo!.git && this.actuatorInfo!.build) {
      const commit = this.actuatorInfo!.git.commit
      const bld = this.actuatorInfo!.build
      this.buildInfo = {
        commit: {id: commit.id, time: this.formatDisplay(commit.time)},
        build: {number: bld.number, time: this.formatDisplay(bld.time)},
      }
    }
  }

  get username() {
    return this.authenticationService.user?.username ?? "..."
  }

  onMenuClick() {
    this.$emit("menu-clicked")
  }

  async onLogout() {
    this.planService.removePlanFromSessionStorage()
    await this.authenticationService.logout()
  }

  private formatDisplay(at: string): string {
    return format(new Date(at), "dd/MM/yyyy HH:mm")
  }
}
